import { TableCell, TableRow } from '@mui/material';
import clsx from 'clsx';

import { memo } from 'react';

import { BaseRow } from '../types';
import { SubRowProps } from './types';

/** TECH_DEBT
 * Animation is disabled for now because it causes issues with the virtualization
 *
 */
const SubRow: React.FunctionComponent<SubRowProps> = ({
  enabled,
  expanded,
  row,
  Component,
  classes,
}) => {
  if (!enabled) {
    return null;
  }

  return (
    <TableRow className={clsx(classes.subRow)}>
      <TableCell
        colSpan={1000}
        className={clsx(classes.subRowCell, { [classes.expandedSubRow]: expanded })}
      >
        {/*  This component renders expanded to measure the content for animation, then quickly hides. Need better approach for these 
        <Offscreen>
          <Contract isMounted={expanded} direction={AnimationDirection.TO_BOTTOM}>
            {!!Component && <Component row={row as BaseRow} />}
          </Contract>
        </Offscreen> 
        */}

        {!!Component && expanded && <Component row={row as BaseRow} />}
      </TableCell>
    </TableRow>
  );
};

export default memo(SubRow);
